import React from "react"
import Helmet from "react-helmet"

import Layout from "../components/layout"

const Resources = () => (
  <Layout>
    <Helmet title="Resources | Roberttables" />
    <h1>Resources Page</h1>
  </Layout>
)

export default Resources
